<template>
  <div id="app">
    <router-view v-wechat-title='$route.meta.title'></router-view>
  </div>
</template>
<script>
export default {
  created () {

  }
}
</script>
<style >
.el-table__header tr,
.el-table__header th {
  padding: 0;
  color: #3b3b3b;
  background: #f3f2f2;
  height: 40px;
}
.el-table__body tr,
.el-table__body td {
  padding: 0;
  height: 40px;
}

.customer-input-wrap {
  display: flex;
  align-items: center;
}

.customer-input-wrap .el-input {
  flex: 1;
}

.el-table .el-table__cell {
  padding: 8px 0 !important;
}
</style>


